import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Components
import ModalCustomized from '../../../../../components/Modal/Modal';
import TextField from '../../../../../components/TextField';

//API
import secretaria_api from '../../../../../api/secretaria_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateSecretaria() {
    return {
        identificacao: "",
        responsavel: "",
        status: "Ativo",
        trabalhaSabado: "Sim",
        trabalhaDomingo: "Não",
        logotipo: ""
    }
}

function CadastroSecretaria({ id = null, setSecretaria_id, isVisibleModal, toggle }) {
    //State para criar / editar
    const [secretaria, setSecretaria] = useState(initialStateSecretaria());

    const { setLoading } = useAuth();

    //State para pegar erros
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "responsavel", required: true }),
        objCampo({ name: "logotipo", required: true })
    ]);

    const loadSecretariaItem = (id) => {
        if (id != null) {
            setLoading(true);
            secretaria_api.getItem(id)
                .then(reponse => {
                    reponse.data.trabalhaDomingo = reponse.data.trabalhaDomingo == true ? "Sim" : "Não";
                    reponse.data.trabalhaSabado = reponse.data.trabalhaSabado == true ? "Sim" : "Não";
                    setSecretaria(reponse.data)
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    //Função de onChange do arquivo da logotipo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setSecretaria({
                ...secretaria,
                logotipo: base64
            });
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    }
    useEffect(() => {
        loadSecretariaItem(id);
    }, []);


    const onChange = (e) => {
        const { name, value } = e.target;
        const _secretaria = {
            ...secretaria,
            [name]: value
        }

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_secretaria, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setSecretaria(_secretaria);
    }

    const handleSubmit = () => {
        const _errors = validarCampos(secretaria, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _secretaria = { ...secretaria }
        _secretaria.trabalhaDomingo = _secretaria.trabalhaDomingo == "Sim";
        _secretaria.trabalhaSabado = _secretaria.trabalhaSabado == "Sim";

        setLoading(true);
        if (_secretaria.id) {
            secretaria_api.put(_secretaria)
                .then(response => {
                    showMessage("Sucesso", "Secretaria Atualizada com sucesso", "success", () => {
                        setSecretaria(initialStateSecretaria());
                        setSecretaria_id(null);
                        toggle()
                    })
                }).catch(e => showMessage("Error", "Error ao atualizar secretaria", "error", null))
                .finally(() => setLoading(false))
        } else {
            secretaria_api.post(_secretaria)
                .then(response => {
                    showMessage("Sucesso", "Secretaria Adicionada com sucesso", "success", () => {
                        setSecretaria(initialStateSecretaria());
                        setSecretaria_id(null);
                        toggle()
                    })
                }).catch(e => showMessage("Error", "Error ao adicionar secretaria", "error", null))
                .finally(() => setLoading(false))
        }
    }
    return <>
        {isVisibleModal && <>
            <ModalCustomized
                title={"+ Adicionar Secretaria"}
                isOpen={isVisibleModal}
                toggle={toggle}
                btnClose={toggle}
                btnActionColor="success"
            >
                <Row>
                    <Col md="6">
                        <TextField
                            label={<><span className='text-danger'>* </span>Identificação</>}
                            name={"identificacao"}
                            value={secretaria.identificacao}
                            onChange={onChange}
                            invalid={!!errors.identificacao}
                        />
                    </Col>
                    <Col md="6">
                        <TextField
                            label={<><span className='text-danger'>* </span>Responsável</>}
                            name={"responsavel"}
                            value={secretaria.responsavel}
                            onChange={onChange}
                            invalid={!!errors.responsavel}
                        />
                    </Col>
                    <Col md="4">
                        <TextField
                            label={<><span className='text-danger'>* </span>Status</>}
                            name={"status"}
                            type={"select"}
                            value={secretaria.status}
                            options={[
                                { value: "Ativo", label: "Ativo" },
                                { value: "Inativo", label: "Inativo" }
                            ]}
                            onChange={onChange}
                        />
                    </Col>
                    <Col md="4">
                        <TextField
                            label={<><span className='text-danger'>* </span>Trabalha Sábado</>}
                            name={"trabalhaSabado"}
                            type={"select"}
                            value={secretaria.trabalhaSabado}
                            options={[
                                { value: "Sim", label: "Sim" },
                                { value: "Não", label: "Não" }
                            ]}
                            onChange={onChange}
                        />
                    </Col>
                    <Col md="4">
                        <TextField
                            label={<><span className='text-danger'>* </span>Trabalha Domingo</>}
                            name={"trabalhaDomingo"}
                            type={"select"}
                            value={secretaria.trabalhaDomingo}
                            options={[
                                { value: "Sim", label: "Sim" },
                                { value: "Não", label: "Não" }
                            ]}
                            onChange={onChange}
                        />
                    </Col>
                    <Col md="12">
                        <TextField
                            label={<><span className='text-danger'>* </span>Logotipo</>}
                            name={"logotipo"}
                            type={"file"}
                            value={secretaria.logotipo}
                            onChange={onChangeAnexo}
                            invalid={!!errors.logotipo}
                        />
                    </Col>
                    {
                        secretaria.logotipo &&
                        <Col md="12" className='d-flex align-items-center justify-content-center mb-3'>
                            <img src={secretaria.logotipo} style={{ width: 150 }} />
                        </Col>
                    }
                </Row>
                <Row className='d-flex justify-content-center mt-3'>
                    <Col md="12" className='m-auto d-flex align-items-center justify-content-center'>
                        <Button
                            color={secretaria.id ? 'warning text-white' : 'success'}
                            style={{ width: 160 }}
                            onClick={handleSubmit}
                        >
                            {secretaria.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                        </Button>
                    </Col>
                </Row>
            </ModalCustomized>
        </>}
    </>;
}

export default CadastroSecretaria;